import { withRouter } from 'react-router';

import Container from './container';
import RegistrationFlow from './registrationFlow';

export default withRouter(Container(RegistrationFlow));



// WEBPACK FOOTER //
// ./src/routes/account/registrationFlow/index.js